export type Feature = {
  id: string;
  label: string;
  description: string;
  placeholder: string;
  helpText: string;
  apiEndpoint: string;
  accentColor: string;
  icon: 'image' | 'audio' | 'screen';
  // Absent/'prompt' = the standard single-textarea input (all existing
  // features). 'screenforge' renders a dedicated multi-field form instead —
  // see AgentDetail.tsx's isScreenForge branch.
  formType?: 'prompt' | 'screenforge';
};

export type AgentDef = {
  id: string;
  name: string;
  role: string;
  initials: string;
  avatarColor: string;
  enabled: boolean;
  features: Feature[];
};

export const AGENTS: AgentDef[] = [
  {
    id: 'scheduler',
    name: '',
    role: 'Scheduler AI agent',
    initials: '',
    avatarColor: '#4a6fa5',
    enabled: false,
    features: [],
  },
  {
    id: 'evv',
    name: '',
    role: 'EVV AI agent',
    initials: '',
    avatarColor: '#5a8a7a',
    enabled: false,
    features: [],
  },
  {
    id: 'ltci',
    name: '',
    role: 'LTCI AI agent',
    initials: '',
    avatarColor: '#8a6a9a',
    enabled: false,
    features: [],
  },
  {
    id: 'receptionist',
    name: '',
    role: 'Receptionist AI agent',
    initials: '',
    avatarColor: '#9a7a5a',
    enabled: false,
    features: [],
  },
  {
    id: 'marketer',
    name: '',
    role: 'Marketer AI agent',
    initials: '',
    avatarColor: '#3a7a8a',
    enabled: true,
    features: [
      {
        id: 'creative_tools',
        label: 'CreativeTools',
        description: 'Generate stunning images from your text descriptions',
        placeholder: 'Describe the image you want to generate...',
        helpText: 'How can I help you with Image Generation?',
        apiEndpoint: 'https://testwizkind.caryfy.ai/wizkind_harness/run',
        accentColor: '#019fd5',
        icon: 'image',
      },
      {
        id: 'text_to_audio',
        label: 'Text to Audio Generation',
        description: 'Convert your text descriptions into audio content',
        placeholder: 'Describe the audio you want to generate...',
        helpText: 'How can I help you with Audio Generation?',
        apiEndpoint: 'https://testwizkind.caryfy.ai/wizkind_harness/creativetools/generate_standalone_audio',
        accentColor: '#09b7aa',
        icon: 'audio',
      },
       {
        id: 'bravoquill',
        label: 'BravoQuill',
        description: 'Generate content',
        placeholder: 'Describe the topic you want to generate...',
        helpText: 'How can I help you with Content Generation?',
        apiEndpoint: 'https://testwizkind.caryfy.ai/wizkind_harness/run',
        accentColor: '#09b7aa',
        icon: 'image',
      },
         {
        id: 'bravomotion',
        label: 'BravoMotion',
        description: 'Generate content for video',
        placeholder: 'Describe the topic you want to generate for video...',
        helpText: 'How can I help you with Content Generation for Video?',
        apiEndpoint: 'https://testwizkind.caryfy.ai/wizkind_harness/run',
        accentColor: '#09b7aa',
        icon: 'image',
      },
    {
        id: 'redpen_review',
        label: 'RedPen',
        description: 'Review Content',
        placeholder: 'Describe the content you want to review...',
        helpText: 'How can I help you with Content Review?',
        apiEndpoint: 'https://testwizkind.caryfy.ai/wizkind_harness/run',
        accentColor: '#09b7aa',
        icon: 'image',
      },
      {
        id: 'signalscout',
        label: 'SignalScout',
        description: 'Scan feeds for content signals',
        placeholder: 'Describe the signal scan you want to run...',
        helpText: 'How can I help you with Signal Scouting?',
        apiEndpoint: 'https://testwizkind.caryfy.ai/wizkind_harness/run',
        accentColor: '#09b7aa',
        icon: 'image',
      },
      {
        id: 'regsentinel',
        label: 'RegSentinel',
        description: 'Scan regulatory sources for changes',
        placeholder: 'Describe the regulatory scan you want to run...',
        helpText: 'How can I help you with Regulatory Scanning?',
        apiEndpoint: 'https://testwizkind.caryfy.ai/wizkind_harness/run',
        accentColor: '#09b7aa',
        icon: 'image',
      },
    ],
  },
  {
    id: 'screenforge',
    name: '',
    role: 'ScreenForge AI agent',
    initials: '',
    avatarColor: '#c2622a',
    enabled: true,
    features: [
      {
        id: 'convert_screen',
        label: 'Convert Screen',
        description: 'Modernize a legacy screen from its old HTML/CSS and a screenshot',
        placeholder: '',
        helpText: 'Fill in the screen details to generate a modernized version',
        apiEndpoint: 'https://testwizkind.caryfy.ai/wizkind_harness/screenforge/convert_screen',
        accentColor: '#c2622a',
        icon: 'screen',
        formType: 'screenforge',
      },
    ],
  },
  {
    id: 'screenforge',
    name: '',
    role: 'ScreenForge AI agent',
    initials: '',
    avatarColor: '#c2622a',
    enabled: true,
    features: [
      {
        id: 'convert_screen',
        label: 'Convert Screen',
        description: 'Modernize a legacy screen from its old HTML/CSS and a screenshot',
        placeholder: '',
        helpText: 'Fill in the screen details to generate a modernized version',
        apiEndpoint: 'https://testwizkind.caryfy.ai/wizkind_harness/screenforge/convert_screen',
        accentColor: '#c2622a',
        icon: 'screen',
        formType: 'screenforge',
      },
    ],
  },
  {
    id: 'recruiter',
    name: 'Ronnie Hireman',
    role: 'Recruiter AI agent',
    initials: '',
    avatarColor: '#7a4a6a',
    enabled: false,
    features: [],
  },
  {
    id: 'manager',
    name: 'Mira Leadson',
    role: 'Manager AI agent',
    initials: '',
    avatarColor: '#6a8a4a',
    enabled: false,
    features: [],
  },
  {
    id: 'analyst',
    name: 'Tina Larson',
    role: 'Analyst AI Agent',
    initials: '',
    avatarColor: '#5a6a8a',
    enabled: false,
    features: [],
  },
];
